import React, { useEffect, useState } from 'react';
import './App.css';

const base = 'https://www.steaknshake.com';

const ordersBasePath = '/orders';
const cateringBasePath = '/catering';

const navItems = [
  {
    label: 'MENU',
    href: '#',
    children: [
      {
        label: 'PRINTABLE MENU',
        href: `${base}/wp-content/uploads/2026/05/Paper_Menu_No-Price_051926_AK.pdf`,
        external: true,
      },
      {
        label: 'NUTRITION & ALLERGENS',
        href: 'https://app.everybite.com/widget/steak-n-shake',
        external: true,
      },
    ],
  },
  { label: 'SEED OILS', href: '/seed-oils' },
  {
    label: 'SPECIALS',
    href: '#',
    children: [{ label: 'Half Price Happy Hour', href: '/menu_specials/half-price-happy-hour/' }],
  },
  {
    label: 'SHOP',
    href: '#',
    children: [
      { label: 'BEEF TALLOW', href: 'https://beeftallow.steaknshake.com/', external: true },
      { label: 'HATS', href: 'http://hats.steaknshake.com/' },
      { label: 'GIFT CARDS', href: '/gift-card/' },
    ],
  },
  { label: 'REWARDS', href: '/rewards' },
  { label: 'ABOUT US', href: '/about-us/' },
  { label: 'CATERING', href: cateringBasePath, embed: 'catering' },
  { label: 'FRANCHISE', href: 'http://www.steaknshakefranchise.com', external: true, className: 'external' },
];

const slides = [
  {
    src: `${base}/wp-content/uploads/2026/05/Grass-Fed-Cows-Desktop.png`,
    alt: 'Home page Banner',
  },
  {
    src: `${base}/wp-content/uploads/2025/05/Bitcoin_Webslider_Desktop_v1.3-100.jpg`,
    alt: 'Bitcoin announcement',
  },
  {
    src: `${base}/wp-content/uploads/2025/03/WebsliderTemplate_Beef-Tallow-Fries_Trademarked.png`,
    alt: 'Desktop Beef Tallow Fries trademark',
    thumbnail: `${base}/wp-content/uploads/2025/03/RFK-Clip-1-Desktop.jpg`,
  },
  {
    src: `${base}/wp-content/uploads/2026/03/SNS_TallowTots_WebsiteBanner_Desktop_1290x550_031626_RB.jpg`,
    alt: 'Beef Tallow Tots',
  },
  {
    src: `${base}/wp-content/uploads/2026/05/Route-66-Desktop.jpg`,
    alt: 'Home page Banner',
  },
];

const footerLinks = [
  ['FEEDBACK', 'https://feedback.steaknshakevisit.com/'],
  ['ASSOCIATES', '/careers'],
  ['TERMS OF USE', '/terms-of-use/'],
  ['PRIVACY POLICY', '/privacy-policy/'],
  ['CALIFORNIA PRIVACY DISCLOSURE', '/california-privacy-disclosure/'],
  ['ACCESSIBILITY STATEMENT', '/accessibility-statement/'],
  ['OUR ANIMAL WELLBEING STANDARDS', '/selective-about-the-food-we-serve/'],
  ['SITE MAP', '/sitemap'],
];

const states = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
];

function App() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [showContact, setShowContact] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(true);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % slides.length);
    }, 30000);

    return () => window.clearInterval(timer);
  }, []);

  // The OnlineOrdering SDK (loaded once via public/index.html) owns the /orders
  // overlay and the nova-orders bundle. The brochure just calls its handlers —
  // no manual CDN <script> injection, no <nova-orders> in this tree anymore.
  const openOrdering = (event) => {
    if (event) event.preventDefault();
    window.OnlineOrdering?.open();
  };
  const openLocations = (event) => {
    if (event) event.preventDefault();
    window.OnlineOrdering?.openLocations();
  };
  // Deep-link a specific store's menu via the new SDK function:
  // OnlineOrdering.openLocation(slug) -> /orders/store/<slug>
  const DEMO_STORE_SLUG = 'fl-casselberry-s-hwy-17-92--02ed9f';
  const openStoreLocation = (event) => {
    if (event) event.preventDefault();
    window.OnlineOrdering?.openLocation(DEMO_STORE_SLUG);
  };

  // CATERING -> the NovaCatering SDK (loaded once via public/index.html) owns
  // the /catering overlay and the nova-catering bundle, the same way the
  // OnlineOrdering SDK owns /orders. Catering is a single Home/Menu
  // experience, so the SDK exposes only open() / openMenu() - no locations.
  const openCatering = (event) => {
    if (event) event.preventDefault();
    window.NovaCatering?.open();
  };

  return (
    <div className="sns-site">
      <header className="wrapper-navbar">
        <nav className="site-navbar" aria-label="Main navigation">
          <button
            className="mobile-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>

          <a href="/" className="brand" aria-label="Steak n Shake home">
            <img
              src={`${base}/wp-content/uploads/2025/06/SNS_Wing_to_Circuit_Logo_Morph_June2025_v1.0-optimized.gif`}
              alt="SNS_logo"
            />
          </a>

          <div className={`main-nav-wrap ${menuOpen ? 'open' : ''}`}>
            <ul className="main-menu">
              {navItems.map((item) => (
                <li key={item.label} className={`${item.children ? 'has-children' : ''} ${item.className || ''}`}>
                  <a
                    href={item.href}
                    target={item.external ? '_blank' : undefined}
                    rel={item.external ? 'noreferrer' : undefined}
                    onClick={item.embed === 'catering' ? openCatering : undefined}
                  >
                    {item.label}
                  </a>
                  {item.children && (
                    <ul className="dropdown-menu">
                      {item.children.map((child) => (
                        <li key={child.label}>
                          <a href={child.href} target={child.external ? '_blank' : undefined} rel={child.external ? 'noreferrer' : undefined}>
                            {child.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="header-location">
            {/* Find a location -> SDK opens /orders/locations (location selector). */}
            <button className="locate-link" onClick={openLocations}>FIND A LOCATION</button>
            <div className="location-panel" aria-label="Find a location">
              <form onSubmit={openLocations}>
                <label htmlFor="search">Find a location</label>
                <div className="location-field">
                  <input id="search" name="q" placeholder="City & State, or Zip Code" />
                  <button aria-label="Search" type="submit" />
                </div>
              </form>
            </div>
          </div>

          {/* Order Online -> SDK opens /orders and mounts the ordering app.
              href kept as a no-JS fallback (a reload lands on /orders, which the
              SDK auto-mounts on load). */}
          <a className="order-online-btn" href={ordersBasePath} onClick={openOrdering}>
            Order Online
          </a>

          {/* Deep-link a specific store: OnlineOrdering.openLocation(slug)
              -> /orders/store/fl-casselberry-s-hwy-17-92--02ed9f */}
          <a
            className="order-location-btn"
            href={`${ordersBasePath}/store/${DEMO_STORE_SLUG}`}
            onClick={openStoreLocation}
          >
            Order from Casselberry, FL
          </a>
        </nav>
      </header>

      <main>
        <section className="slider-container" aria-label="Featured promotions">
          <div className="carousel">
            {slides.map((slide, index) => (
              <div
                className={`slide ${index === activeSlide ? 'active' : ''}`}
                key={slide.src}
                style={{ backgroundImage: `url(${slide.src})` }}
              >
                <img src={slide.src} alt={slide.alt} />
                {slide.thumbnail && (
                  <button className="youtube-thumb" onClick={() => setShowVideo(true)} aria-label="Open Modal">
                    <img src={slide.thumbnail} alt="Open Modal" />
                  </button>
                )}
              </div>
            ))}

            <div className="controls" aria-label="Carousel controls">
              <button className="slide-arrow prev" onClick={() => setActiveSlide((activeSlide + slides.length - 1) % slides.length)} aria-label="Previous slide" />
              <button className="slide-arrow next" onClick={() => setActiveSlide((activeSlide + 1) % slides.length)} aria-label="Next slide" />
              <div className="slidenav">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    className={index === activeSlide ? 'active' : ''}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`View slide ${index + 1}`}
                  />
                ))}
                <button className="pause-btn" aria-label="Pause carousel" />
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="wrapper-footer">
        <div className="footer-top-container">
          <div className="footer-top">
            <div className="footer-special-offer" />
            <div className="footer-links">
              <ul aria-label="footer">
                <li className="footer-bitcoinlogo">
                  <img src={`${base}/wp-content/themes/steaknshake/img/Bitcoin.png`} alt="" />
                </li>
                <li className="footer-action">
                  <a href="/rewards" className="footer-icon-link rewards-link">
                    <span>REWARDS</span>
                    <span>CLUB</span>
                  </a>
                </li>
                <li className="footer-action">
                  <a href="https://steaknshake.ourstory.harri.com/" target="_blank" rel="noreferrer" className="footer-icon-link careers-link">
                    CAREERS
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-social-media">
              <ul className="social-icons" aria-label="social media">
                <li><a href="http://www.facebook.com/steaknshake" target="_blank" rel="noreferrer" className="facebook"><span>facebook icon</span></a></li>
                <li><a href="http://twitter.com/steaknshake" target="_blank" rel="noreferrer" className="twitter"><span>twitter icon</span></a></li>
                <li><a href="http://instagram.com/steaknshake" target="_blank" rel="noreferrer" className="instagram"><span>instagram icon</span></a></li>
                <li><a href="http://youtube.com/steaknshake" target="_blank" rel="noreferrer" className="youtube"><span>youtube icon</span></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <ul className="footer-bottom-links">
            {footerLinks.map(([label, href]) => (
              <li key={label}>
                <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noreferrer' : undefined}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <p className="copyright">
            <span className="copyright-text1">STEAK 'N SHAKE® IS A <a href="http://www.biglariholdings.com/" target="_blank" rel="noreferrer">BIGLARI HOLDINGS COMPANY</a>.</span>
            <span className="copyright-text2">©2026 STEAK 'N SHAKE®</span>
            <span className="copyright-text3">ALL RIGHTS RESERVED.</span>
          </p>
          <div className="footer-sig">
            <img className="biglari-sign" src={`${base}/wp-content/themes/steaknshake/img/biglari-sign.svg`} alt="biglari-sign" />
          </div>
        </div>
      </footer>

      <button className="floating-contact" onClick={() => setShowContact(true)}>Contact Us</button>
      <button className="accessibility-trigger" aria-label="Accessibility options"><span /></button>

      {showCookieBanner && (
        <aside className="cookie-banner" aria-label="Cookie consent">
          <div className="cookie-copy">
            <h3>We value your privacy</h3>
            <p>
              We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic.
              By clicking "Accept All", you consent to our use of cookies.
            </p>
          </div>
          <div className="cookie-actions">
            <button onClick={() => setShowCookieBanner(false)}>Customize</button>
            <button onClick={() => setShowCookieBanner(false)}>Reject All</button>
            <button className="accept" onClick={() => setShowCookieBanner(false)}>Accept All</button>
          </div>
        </aside>
      )}

      {showVideo && (
        <div className="modal-backdrop" role="dialog" aria-modal="true" aria-label="RFK video">
          <div className="video-modal">
            <button className="video-close" onClick={() => setShowVideo(false)} aria-label="Close">×</button>
            <iframe
              title="Steak n Shake video"
              src="https://www.youtube.com/embed/2qqF2YMr3FE?si=LE1uTTmoj93A3wch"
              allowFullScreen
            />
          </div>
        </div>
      )}

      {showContact && (
        <div className="contact-popup-shell" role="dialog" aria-modal="true" aria-labelledby="contact-heading">
          <div className="contact-modal">
            <button className="modal-close" onClick={() => setShowContact(false)} aria-label="Close">×</button>
            <h2 id="contact-heading">Contact Us</h2>
            <form className="contact-form">
              <div className="contact-row two">
                <label>First Name <span>*</span><input name="first-name" /></label>
                <label>Last Name <span>*</span><input name="last-name" /></label>
              </div>
              <label>Email Address <span>*</span><input type="email" name="email" /></label>
              <label>Street Address <span>*</span><input name="street-address" /></label>
              <div className="contact-row two">
                <label>City <span>*</span><input name="city" /></label>
                <label>State <span>*</span>
                  <select defaultValue="" name="state">
                    <option value="">Select State</option>
                    {states.map((state) => <option key={state}>{state}</option>)}
                  </select>
                </label>
              </div>
              <div className="contact-row two">
                <label>ZIP Code <span>*</span><input name="zip" /></label>
                <label>Phone <span>*</span><input type="tel" name="phone" /></label>
              </div>
              <label>Message <span>*</span><textarea name="message" /></label>
              <button type="button">Submit</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
